export default __webpack_public_path__ + "static/media/course_feedback.89aeb427.svg";